// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3JnxM","bigColWidth":"Table_bigColWidth__16myW","biggerColWidth":"Table_biggerColWidth__JKb54","row":"Table_row__3YFUi","col":"Table_col__3CcuI"};